<div class="rx-intuitive-tooth-editor-header" [class.rx-intuitive-tooth-editor-header--no-body]="shouldHideProperties">
	<div class="rx-intuitive-tooth-editor-header__title-row">
		<div class="rx-intuitive-tooth-editor-header__title-left">
			<div class="rx-intuitive-tooth-editor-header__badge-row">
				<rx-intuitive-indication-badge
					[indication]="badgeIndicationId"
				/>
				<span class="rx-intuitive-tooth-editor-header__span-label">
					{{ bridgeSpanLabel }}
				</span>
			</div>
			<span class="rx-intuitive-tooth-editor__tooth-label" *ngIf="teeth.length > 0">
				{{ 'ToothEditor.ToothNumberHash' | translate }}{{ toothNumbersLabel }}
			</span>
		</div>
		<button
			*ngIf="canDelete"
			tlkButton
			class="rx-intuitive-tooth-editor-header__indication-delete-btn"
			[variant]="'ghost'"
			[size]="'l'"
			[attr.aria-label]="'ToothEditor.Delete' | translate"
			(click)="signalDeleteBridge()"
		>
			<tlk-delete-icon />
		</button>
	</div>
</div>
<rx-intuitive-tooth-editor-body
	*ngIf="!shouldHideProperties"
	[teeth]="teeth"
	[isReadOnly]="isReadOnly"
	[isBridge]="true"
	[isInvalid]="teeth[0]?.isInvalid ?? false"
	[teethFlatOverride]="bridgeTeethFlat"
	[ponticDesigns]="ponticDesigns"
	(crownFormChanged)="onBodyCrownFormChanged($event)"
	(additionalInfoApplied)="onBodyAdditionalInfoApplied($event)"
	(clearDisabledFields)="onBodyClearDisabledFields($event)"
	(ponticDesignChanged)="onBodyPonticDesignChanged($event)"
></rx-intuitive-tooth-editor-body>
